import React from "react";
import { QRCode } from '../qrcode'
import PointBase from "./Base/PointBase";
import { pointOptions } from "./ultil";

/**
 * @QrProvider(
 *   id = "heart",
 *   title = @Translation("Heart")
 * )
 */
export default class RendererHeart extends PointBase {

	/**
	 * constructor
	 * @param $options
	 * @param $qrcode
	 * @param $name
	 */
	constructor($options: any = {}, $qrcode: QRCode, $name?: string) {
		
		const pointRender = ($options: any) => {
			let $opts = pointOptions($options, ['transform', 'fill'], [], function ($opts: any){
				let { x, y, scale } = $opts || {};
				return Object.assign($opts, { "transform": `translate(${x},${y}) scale(${scale})` });
			});
			
			return (<path {...$opts} d="M100.013 26.0566C98.354 12.685 88.397 2.65629 75.1212 0.984841C65.1644 -0.686609 56.8671 4.32774 50.2292 11.0135C43.5913 4.32774 35.2939 0.984841 26.9965 0.984841C13.7207 2.65629 2.10439 12.685 0.444923 26.0566C0.444923 34.4138 2.10439 41.0996 5.42335 46.1139C7.08282 47.7854 8.74233 49.4568 10.4017 51.1283L41.9318 87.9001C46.9102 92.9145 53.5481 92.9145 56.8671 87.9001L86.7375 56.1426C88.397 54.4712 91.716 51.1283 93.3754 47.7854C98.354 42.771 101.673 34.4138 100.013 26.0566Z"/>);
		}
		
		Object.assign($options, {"pos": pointRender})
		
		super($options, $qrcode, $name || 'RendererHeart');
	}
}
